import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'ansprechpartnerin',
  heading: 'Ansprechpartner:innen',
  fields: {
    pm: 'Verantwortliche:r PM',
    fachkraft: 'Verantwortliche Fachkraft',
    teamPlanning: 'Verantwortliche:r Team Planning',
  },
} as const;
